import { t } from './translate';
const MINUTES_PER_HOUR = 60;
const MINUTES_PER_DAY = 24 * MINUTES_PER_HOUR;
const ROUND_TO_MINUTES = 15;
const pad = (n) => String(n).padStart(2, '0');
export function splitDuration(totalMinutes) {
    const total = Math.max(0, Math.floor(totalMinutes !== null && totalMinutes !== void 0 ? totalMinutes : 0));
    return {
        days: Math.floor(total / MINUTES_PER_DAY),
        hours: Math.floor((total % MINUTES_PER_DAY) / MINUTES_PER_HOUR),
        minutes: total % MINUTES_PER_HOUR
    };
}
export function joinDuration({ days, hours, minutes }) {
    return days * MINUTES_PER_DAY + hours * MINUTES_PER_HOUR + minutes;
}
/** `1 day 2 hrs 30 mins`: zero parts dropped, `0 mins` for nothing. */
export function formatDuration(totalMinutes) {
    const { days, hours, minutes } = splitDuration(totalMinutes);
    const parts = [];
    if (days > 0)
        parts.push(t('units.day', { count: days }));
    if (hours > 0)
        parts.push(t('units.hour', { count: hours }));
    if (minutes > 0 || parts.length === 0)
        parts.push(t('units.minute', { count: minutes }));
    return parts.join(' ');
}
/** `14:00` -> `2:00 pm`. Anything that is not HH:MM comes back unchanged. */
export function formatTime12h(time) {
    const match = /^(\d{1,2}):(\d{2})$/.exec(time);
    if (!match)
        return time;
    const hour = Number(match[1]);
    return `${hour % 12 || 12}:${match[2]} ${hour < 12 ? 'am' : 'pm'}`;
}
/** The wall-clock time now in `timeZone` (IANA), rounded down to 15 minutes, as HH:MM (24h). */
export function nowRoundedDown(timeZone, at = new Date()) {
    const format = (zone) => new Intl.DateTimeFormat('en-US', { timeZone: zone, hour: '2-digit', minute: '2-digit', hourCycle: 'h23' });
    let formatter;
    try {
        formatter = format(timeZone);
    }
    catch (_a) {
        formatter = format(undefined);
    }
    const parts = Object.fromEntries(formatter.formatToParts(at).map((part) => [part.type, part.value]));
    const hour = Number(parts.hour) % 24;
    const minute = Math.floor(Number(parts.minute) / ROUND_TO_MINUTES) * ROUND_TO_MINUTES;
    return `${pad(hour)}:${pad(minute)}`;
}
export function formatDate(date) {
    return `${pad(date.getMonth() + 1)}/${pad(date.getDate())}/${date.getFullYear()}`;
}
export function parseDate(value) {
    const match = /^(\d{2})\/(\d{2})\/(\d{4})$/.exec(value);
    if (!match)
        return null;
    const date = new Date(Number(match[3]), Number(match[1]) - 1, Number(match[2]));
    return date.getMonth() === Number(match[1]) - 1 ? date : null;
}
export function formatTime(date) {
    return `${pad(date.getHours())}:${pad(date.getMinutes())}`;
}
export function parseTime(value) {
    const match = /^(\d{2}):(\d{2})$/.exec(value);
    if (!match)
        return null;
    const date = new Date();
    date.setHours(Number(match[1]), Number(match[2]), 0, 0);
    return date;
}
